import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import SearchResponse from "../../response/search.response";
import { Observable } from "rxjs/Rx";
import { PermissionsHelper } from "src/app/helpers/Permission";

@Injectable({
  providedIn: "root",
})
export class OpportunitiesService {
  constructor(private api: ApiService, private permission: PermissionsHelper) {}

  public getList(params): Observable<any> {
    if (params instanceof SearchResponse) {
      params = params.getReqData();
    }
    return this.api.get("/opportunities", {
      params: params,
      headers: {
        Permissions: this.permission.getJWT("opportunities"),
      },
    });
  }

  public getAllOpportunities(params): Observable<any> {
    if (params instanceof SearchResponse) {
      params = params.getReqData();
    }
    return this.api.get("/opportunities/tech", {
      params: params,
      headers: {
        Permissions: this.permission.getJWT("opportunities"),
      },
    });
  }

  public getOpportunitiesByLeadNumber(leadNumber): Observable<any> {
    return this.api.get("/opportunities/lead/" + leadNumber, {
      headers: {
        Permissions: this.permission.getJWT("opportunities"),
      },
    });
  }

  public createPartial(id, data): Observable<any> {
    return this.api.post("/opportunities/" + id + "/partial", {
      body: data,
      headers: {
        Permissions: this.permission.getJWT("opportunities"),
      },
    });
  }
  public deleteOpportunities(ids): Observable<any> {
    return this.api.post("/opportunities/delete", {
      body: {
        opportunity_ids: ids,
      },
      headers: {
        Permissions: this.permission.getJWT("opportunities"),
      },
    });
  }

  public downloadOpportunity(
    params,
    ids = [],
    type = { result: 0, password: 0 }
  ): Observable<any> {
    if (params instanceof SearchResponse) {
      params = params.getReqData();
    }
    params = Object.assign(params, { password: type.password });
    if (ids.length > 0 && type.result === -1) {
      return this.api.get("/opportunities?excel=all&excel_users=" + ids, {
        params: params,
        responseType: "text",
        headers: {
          Permissions: this.permission.getJWT("opportunities"),
        },
      });
    } else if (type.result === 1) {
      return this.api.get("/opportunities?excel=all", {
        params: params,
        responseType: "text",
        headers: {
          Permissions: this.permission.getJWT("opportunities"),
        },
      });
    } else if (type.result === 2) {
      return this.api.get("/opportunities?excel=" + params.page_size, {
        params: params,
        responseType: "text",
        headers: {
          Permissions: this.permission.getJWT("opportunities"),
        },
      });
    }
  }

  public getDetails(params): Observable<any> {
    return this.api.get("/opportunities/get-details", {
      params,
      headers: {
        Permissions: this.permission.getJWT("opportunities"),
      },
    });
  }
}
